<template>
  <div class="service-advantages">
    <div class="title">服务优势</div>
    <div class="content-list">
      <div class="content-list-item">
        <div class="pic" />
        <div class="sub-title">全国能源补给网络</div>
        <div class="desc">加油网络覆盖1800座城市，畅行全国，随时随地便捷加油。</div>
      </div>
      <div class="content-list-item">
        <div class="pic" />
        <div class="sub-title">企业用油便捷管理</div>
        <div class="desc">线上分油、线下加油，无需圈存。免垫付、免贴票、流程短</div>
      </div>
      <div class="content-list-item">
        <div class="pic" />
        <div class="sub-title">数据清晰透明</div>
        <div class="desc">加油订单透明，企业管控燃油消费，防舞弊降费用。</div>
      </div>
      <div class="content-list-item">
        <div class="pic" />
        <div class="sub-title">合规发票流程</div>
        <div class="desc">预设燃油预算，开具燃油增值税发票抵扣进项，节约成本。</div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.service-advantages {
  padding: 20px;
  margin-top: 16px;
  border-radius: 16px;
  background: #fff;

  .title {
    font-weight: 600;
    color: #1d2129;
    font-size: 20px;
    margin-bottom: 16px;
    line-height: 32px;
  }

  .content-list {
    display: flex;
    justify-content: space-between;

    .content-list-item {
      flex: 1;
      flex-shrink: 0;
      padding: 12px 12px 24px;
      border-radius: 12px;
      background: rgba(244, 248, 255, 0.8);
      margin-right: 12px;

      &:last-child {
        margin-right: 0;

        .pic {
          background-image: url(https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/serve04.png);
        }
      }

      &:nth-child(2) {
        .pic {
          background-image: url(https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/serve02.png);
        }
      }

      &:nth-child(3) {
        .pic {
          background-image: url(https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/serve03.png);
        }
      }

      .pic {
        width: 40px;
        height: 40px;
        flex-shrink: 0;
        background: url(https://nl-frontend-test-1305297355.cos.ap-beijing.myqcloud.com/nl-saas/overview/serve01.png) no-repeat center center;
        background-size: contain;
      }

      .sub-title {
        color: #1d2129;
        font-size: 16px;
        font-weight: 500;
        padding: 12px 0 8px 0;
      }

      .desc {
        color: #86909c;
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
}
</style>
